
import { createContext } from 'react';
import { Session, Animal } from './Types';


export const GlobalState = {
    state: { 
      current: {
        date: new Date(),
        herd: '',
        tagNumber: 0,
        tailCondition: '',
        activeInjury: false,
        highSevereCount: 0,
        highMildCount: 0,
        midSevereCount: 0,
        midMildCount: 0,
        lowSevereCount: 0,
        lowMildCount: 0,
        dockedPosition: '',
      },
      previous: {
        date: new Date(),
        herd: '',
        tagNumber: 0,
        tailCondition: '',
        activeInjury: false,
        highSevereCount: 0,
        highMildCount: 0,
        midSevereCount: 0,
        midMildCount: 0,
        lowSevereCount: 0,
        lowMildCount: 0,
        dockedPosition: '',
      },
      session_id: 1,
      herd: '',
      date: new Date(),
      animals: [] as Animal[],
    },
    setState: (state: Session) => { } 
};


export const AppContext = createContext(GlobalState);
 



